import type { TableColumn } from '@data/components/basic/Table/types';
import type { ProductCode } from '@data/config/reports';
import type { MetricsTableV2Response } from '@data/hooks/api/use-metrics-table-v2-api/use-metrics-table-v2-api';
import { resolveColumnKeys, type ColumnRule } from './resolve-columns';

export function filterTableData(
  data: MetricsTableV2Response | undefined,
  columnRules: ColumnRule[],
  edApp: ProductCode
) {
  if (!data) {
    return { visibleColumns: [] as TableColumn[], visibleRows: [] };
  }

  const allowedKeys = resolveColumnKeys(columnRules, edApp);
  const keptIndices: number[] = [];
  const cols = data.columns.filter((col, i) => {
    const key = 'key' in col ? col.key : undefined;
    const keep = col.type === 'id' || (key != null && allowedKeys.has(key));
    if (keep) {
      keptIndices.push(i);
    }
    return keep;
  }) as TableColumn[];
  const rows = data.rows.map((row) => keptIndices.map((i) => row[i]));

  return { visibleColumns: cols, visibleRows: rows };
}
